export default {
      id: "icon-customer-review-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-customer-review",
      toString: function () {
        return this.url;
      }
    }